import { render } from "./BrandsPopUpFilterItemsScroll.vue?vue&type=template&id=3531b345&scoped=true"
import script from "./BrandsPopUpFilterItemsScroll.vue?vue&type=script&lang=js"
export * from "./BrandsPopUpFilterItemsScroll.vue?vue&type=script&lang=js"

import "./BrandsPopUpFilterItemsScroll.vue?vue&type=style&index=0&id=3531b345&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3531b345"],['__file',"src/components/BrandsPopUpFilterItemsScroll.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3531b345"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3531b345', __exports__)) {
    api.reload('3531b345', __exports__)
  }
  
  module.hot.accept("./BrandsPopUpFilterItemsScroll.vue?vue&type=template&id=3531b345&scoped=true", () => {
    api.rerender('3531b345', render)
  })

}


export default __exports__